import React from 'react';
import { View } from 'react-native';
import type { Meta, StoryObj } from '@storybook/react';

import { InfoCard } from './InfoCard';

const meta = {
  title: 'Diary/InfoCard',
  component: InfoCard,
  args: {
    title: 'How to do it',
    body: 'Every evening, write down three things you are grateful for. Small things count: a good coffee, a kind word, a moment of quiet.',
  },
  decorators: [
    Story => (
      <View style={{ width: 340 }}>
        <Story />
      </View>
    ),
  ],
} satisfies Meta<typeof InfoCard>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};
